<div class="mt-auto p-6 pt-0 text-center dark:text-white-dark ltr:sm:text-right rtl:sm:text-left">© {{ currYear }} P-Gate - Process Gate Systems</div>
